import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { ClientSidePaginationList } from '../../hoc/ClientSidePaginationList.jsx';
import { DEPARTMENTS } from '../../../config';
import { setLastBreadcrumbsArray, setPageHeadObject } from '../../actions/app';

import { getModerOffersList, uploadOfferImage } from '../../actions/shop';
import { getVisibleModeratorShopOffers } from '../../reducers/shop-selector';
import OffersItem from '../Offers/OffersItem.jsx';


const ModeratorOffers = ({ isLoading, setPageHeadObject, setLastBreadcrumbsArray,
                           count, paginateList, is_moderator, uploadOfferImage }) => {
  let { type } = useParams();
  useEffect(() => {
    const title = DEPARTMENTS['moderator']['children'][type]['title'];
    setPageHeadObject({ title });
    setLastBreadcrumbsArray({ title, url: `/${type}/` });
  }, []);

  let items = [];
  if (!isLoading) {
    if (count){
      items = paginateList.map(item => <OffersItem key={ item.id } {...item}
                                                   onChangeImage={ uploadOfferImage }
                                                   showChangeImage={ true }
                                                   is_moderator={ is_moderator }
                                                   scaleImage={ true }
                                                   type={ type }/>);
    } else {
      items = <p>{ gettext('Ничего не найдено.') }</p>;
    }
  }
  return <div className='pt-2'>{ items }</div>
}

ModeratorOffers.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  setPageHeadObject: PropTypes.func.isRequired,
  setLastBreadcrumbsArray: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  paginateList: PropTypes.array.isRequired,
  is_moderator: PropTypes.bool.isRequired,
  uploadOfferImage: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    list: getVisibleModeratorShopOffers(state),
    is_moderator: state.auth.is_moderator,
  }
};

export default compose(
  connect(mapStateToProps, { loadListFromServer: getModerOffersList, uploadOfferImage,
    setLastBreadcrumbsArray, setPageHeadObject }),
  LoginRequired,
  Page,
  ClientSidePaginationList
)(ModeratorOffers);

